import script from "./ForumThread.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForumThread.vue?vue&type=script&setup=true&lang=ts"

import "./ForumThread.vue?vue&type=style&index=0&id=d21f81b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d21f81b2"]])

export default __exports__